import React, { useState } from 'react';
import * as S from './TreeNode.style';

const TreeNode = ({ 
  node, 
  isRoot = false, 
  isFirstChild = false,
  onToggle,
  checkedNodes 
}) => {
  console.log('🔥 [DEBUG] TreeNode 렌더링:', node.name, 'isRoot:', isRoot);
  
  const [isExpanded, setIsExpanded] = useState(isFirstChild);
  
  const isTerminal = !node.children || node.children.length === 0;
  const nodeKey = JSON.stringify(node);
  const isChecked = checkedNodes.has(nodeKey);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const handleCheck = () => {
    console.log('🔥 [DEBUG] TreeNode handleCheck 호출됨:', node.name);
    console.log('🔥 [DEBUG] onToggle 함수:', typeof onToggle);
    
    if (onToggle) {
      onToggle(node);
    } else {
      console.error('🔥 [ERROR] onToggle 함수가 없습니다!');
    }
  };

  // 루트 노드는 렌더링하지 않고 자식들만 렌더링
  if (isRoot) {
    if (!node.children || node.children.length === 0) {
      return null;
    }

    return (
      <div>
        {node.children.map((child, index) => (
          <TreeNode
            key={index}
            node={child}
            isRoot={false}
            isFirstChild={index === 0}
            onToggle={onToggle}
            checkedNodes={checkedNodes}
          />
        ))}
      </div>
    );
  }

  return (
    <S.NodeContainer>
      <S.NodeHeader>
        <S.NodeContent>
          <S.Checkbox
            type="checkbox"
            checked={isChecked}
            onChange={handleCheck}
          />
          <S.NodeName>{node.name}</S.NodeName>
        </S.NodeContent>
        {!isTerminal && (
          <S.ToggleButton onClick={handleToggle}>
            {isExpanded ? '닫기' : '열기'}
          </S.ToggleButton>
        )}
      </S.NodeHeader>
      
      {isExpanded && node.children && (
        <S.ChildrenContainer>
          {node.children.map((child, index) => (
            <TreeNode
              key={index}
              node={child}
              isRoot={false}
              isFirstChild={false}
              onToggle={onToggle}
              checkedNodes={checkedNodes}
            />
          ))}
        </S.ChildrenContainer>
      )}
    </S.NodeContainer>
  );
};


export default TreeNode;